import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Alert,
  Button,
  Icon,
  Layout,
  Input,
  Table,
  Badge,
  Tooltip
} from 'antd';

import AdminHeader from '../../components/AdminHeader/AdminHeader';
import Footer from '../../components/Footer/Footer';
import classes from './DocumentsTraining.css';
import { documentTypes }  from "../../components/DocumentForm/DocumentForm";
import FileLink from "../../components/FileLink/FileLink";

import isAuthenticated from '../../utils/isAuthenticated';
import { getDocumentsTrainingSearchRequest } from '../../api/requests';
import { logout } from "../../reducers/user/actions";
import { getUserTrainingReadPermission } from "../../reducers/user/selectors";

const routes = require('../../routes.json');

const { Content } = Layout;
const { Search } = Input;

class DocumentsTraining extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      documents: [],
      nameSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      sites: [],
      site: null,
      filter: null,
      order: 'asc',
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      eventsSelected: {},
      sortedInfo: { columnKey: 'order_index', order: 'ascend'},
      documentEdit: null,
    };
  }

  async componentDidMount() {
    this.onNameSearch();
  }

  onNameSearch = async (value) => {
    this.setState({ nameSearch: value, filter: null, site: null, eventsSelected: {} }, this.getDocuments);
  };

  getDocuments = async (page = this.state.currentPage, per_page = this.state.pageSize) => {
    this.setState({ errorMessage: null, isLoading: true, responseMessage: null });

    try {
      const { data } = await getDocumentsTrainingSearchRequest({
        nameSearch: this.state.nameSearch,
        order_direction: this.state.order,
        page,
        per_page,
        order_column: get(this.state, 'sortedInfo.columnKey'),
      });

      if (Array.isArray(data.data)) {
        this.setState({ documents: data.data, total: data.total_pages * per_page, currentPage: page });
      } else {
        this.setState({ documents: [data], total: 1 * per_page, currentPage: page });
      }
    } catch (e) {
      if (get(e, 'response.status') === 401) { this.props.logout();  return; }
      this.setState({ documents: null, errorMessage: get(e, 'response.data.error', 'Error') });
    }

    this.setState({ isLoading: false });
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState({
      isLoading: true,
      pageSize: pagination.pageSize,
      sortedInfo: sorter,
      order: get(sorter, 'order') === 'ascend' ? 'asc' : get(sorter, 'order') === 'descend' ? 'desc' : 'asc',
    }, () => this.getDocuments(pagination.current, pagination.pageSize));
  };

  render() {
    const { errorMessage, isLoading, responseMessage, nameSearch, documents, currentPage, total, pageSize, sortedInfo } = this.state;
    const { userTrainingReadPermission } = this.props;

    const columns = [
      {
        dataIndex: "order_index",
        key: "order_index",
        title: "Index",
        render: val => (<span>{val}</span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'order_index' && sortedInfo.order,
      },
      {
        dataIndex: "name",
        key: "name",
        title: "Document Name",
        render: (val, record) => (<div className={classes.nameDocumentWrapper}>
          <div style={{ width: '86px' }}>
            <Badge count={record.state} style={{ backgroundColor: record.state === 'active' ? '#52c41a' : '#777' }} />
            <br/>
            {record.state === 'active' && <Badge count={record.approved ? 'approved' : 'unapproved'} style={{ backgroundColor: record.approved ? '#52c41a' : '#777' }} />}

          </div>
          {val}
        </div>)
      },
      {
        dataIndex: "type",
        key: "type",
        title: "Document Type",
        render: val => (<span>{documentTypes[val]}</span>)
      },
      {
        dataIndex: "site",
        key: "site",
        title: "Site",
        render: site => get(site, 'name')
      },
      {
        dataIndex: "start_year",
        key: "start_year",
        title: "Start date",
      },
      {
        dataIndex: "expiry_year",
        key: "expiry_year",
        title: "Expiry date",
      },
      {
        dataIndex: "user",
        key: "user",
        title: "Uploaded by",
        render: user => get(user, 'username')
      },
      {
        dataIndex: "id",
        key: "id",
        title: "Actions",
        render: (val, document) => (<div className={classes.actions}>
          <FileLink url={document.url} />
        </div>)
      },
    ];

    return (
        <div style={{ backgroundColor: '#FAFAFA' }}>
            <Layout className={classes.parentContainer}>
                <AdminHeader />
                <Content className={classes.content}>
                  <h3 className='headline-default'>Training Documents</h3>

                  <div className={classes.searchWrapper}>
                    <label className={classes.searchWrapperSearch}>
                      <b className={classes.searchWrapperLabel}>SEARCH</b>
                      <Search
                        placeholder="By name"
                        enterButton="Search"
                        size="large"
                        onSearch={this.onNameSearch}
                        value={nameSearch}
                        onChange={this.onNameChange}
                        style={{ maxWidth: '500px'}}
                      />
                    </label>
                  </div>

                  {userTrainingReadPermission && <div style={{ margin: '20px 0' }}>
                    <Link to={routes.admin.training}><Button type='primary'>Go to quiz</Button></Link>
                  </div>}

                  {errorMessage && (<Alert type='error' message={errorMessage} />)}

                  {responseMessage && (<Alert type='success' message={responseMessage} />)}

                  <Table
                    columns={columns}
                    dataSource={documents}
                    loading={isLoading}
                    rowKey="id"
                    onChange={this.handleTableChange}
                    pagination={{
                      onShowSizeChange: (current, size) => {
                        this.setState({ pageSize: size });
                      },
                      current: currentPage,
                      total,
                      pageSize,
                      showSizeChanger: true,
                      pageSizeOptions: ['10', '25', '50', '100']
                    }}
                  />

                  {isLoading && <Icon type="loading" />}
                </Content>
                <Footer noAdminLink />
            </Layout>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTrainingReadPermission: getUserTrainingReadPermission(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(connect(mapStateToProps, mapDispatchToProps)(DocumentsTraining));



// WEBPACK FOOTER //
// ./src/containers/DocumentsTraining/DocumentsTraining.js